// JOBE-0167.1: MemoryTabBar — four tabs with Cedar capability chips.
//
// Tabs (left-to-right): Memories · Forget log · Decay · Health.
// Each tab shows a memory:read capability chip next to its label so
// the operator can see at a glance whether read access is permitted.
//
// The Memories tab additionally surfaces a cluster of write-action
// chips (memory:correct, memory:explain, memory:forget) so the
// operator can preview which inspect-view actions are permitted
// before opening a row (per the W8 screen-guide wireframe).
//
// Capability state comes from useCedarCapabilities() (see
// ./useCedarCapabilities.js). Tab buttons themselves remain
// clickable regardless of capability — the chip is the gate
// indicator; actual action gating happens in JOBE-0167.4.

import { useCedarCapabilities } from './useCedarCapabilities.js';
import { CedarCapabilityChip } from './CedarCapabilityChip.jsx';

export const TAB_KEYS = ['memories', 'forget-log', 'decay', 'health'];

const TABS = [
  { key: 'memories',   label: 'Memories' },
  { key: 'forget-log', label: 'Forget log' },
  { key: 'decay',      label: 'Decay' },
  { key: 'health',     label: 'Health' },
];

// Write-action chips shown only on the Memories tab cluster.
const MEMORIES_WRITE_CHIPS = ['memory:correct', 'memory:explain', 'memory:forget'];

export function MemoryTabBar({ activeTab, onTab }) {
  const caps = useCedarCapabilities();

  return (
    <div
      className="memory-tab-bar"
      role="tablist"
      aria-label="Memory governance tabs"
    >
      {TABS.map((tab) => {
        const active = tab.key === activeTab;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            data-tab-key={tab.key}
            className={
              'memory-tab-bar__tab' + (active ? ' memory-tab-bar__tab--active' : '')
            }
            onClick={() => onTab(tab.key)}
          >
            <span className="memory-tab-bar__label">{tab.label}</span>
            <CedarCapabilityChip
              capability="memory:read"
              state={caps['memory:read']}
            />
            {tab.key === 'memories' && (
              <span
                className="memory-tab-bar__write-chips"
                data-testid="memories-write-chip-cluster"
              >
                {MEMORIES_WRITE_CHIPS.map((c) => (
                  <CedarCapabilityChip
                    key={c}
                    capability={c}
                    state={caps[c]}
                  />
                ))}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default MemoryTabBar;
